<h1 class="title-modal" mat-dialog-title>
  <strong>Table Configuration</strong>
  <mat-icon (click)="onClose(false)">close</mat-icon>
</h1>
<mat-divider class="divider"></mat-divider>
<form [formGroup]="tableVisualization" (ngSubmit)="onSubmit()">
  <mat-form-field fxFill appearance="fill">
    <mat-label>Name</mat-label>
    <input matInput id="name" formControlName="name" type="text" placeholder="Enter the name" />
  </mat-form-field>

  <div class="form1_container">
    <div>
      <mat-form-field fxFill appearance="fill">
        <mat-label>Name</mat-label>
        <input matInput id="name" formControlName="tableName" type="text" placeholder="Enter the target table" />
      </mat-form-field>
    </div>

    <div>
      <mat-form-field fxFill appearance="fill">
        <mat-label>Connection DB</mat-label>
        <mat-select placeholder="Column type" formControlName="connectionDBId">
          @for (item of tableVisualizationUpdated.connectionDBS; track item.id) {
          <mat-option [value]="item.id">{{ item.name !== null ? item.name : 'toto' }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="updatable-container">
    <span class="filterable-checkbox">PK</span>
    <span class="filterable-checkbox">U_U</span>
    <span class="updatable-checkbox">U_D</span>
    <span class="filterable-checkbox">Filterable</span>
    <span class="updatable-checkbox">Updatable</span>
  </div>
  <div class="columns-container" formArrayName="columnCsvList" micScrollBar>
    @for (column of controls; track $index; let i = $index) {
    <div>
      <div [formGroupName]="i" class="column-container">
        <mat-form-field appearance="fill">
          <mat-label>Column</mat-label>
          <input matInput type="text" formControlName="name" [placeholder]="'Column ' + i" />
        </mat-form-field>
        <mat-checkbox
          formControlName="primaryKey"
          (change)="checkboxChanged($event)"
          matTooltip="primaryKey"
          matTooltipPosition="above"
        ></mat-checkbox>
        <mat-checkbox
          formControlName="updateUser"
          (change)="checkboxChanged($event)"
          matTooltip="isFilterable"
          matTooltipPosition="above"
        ></mat-checkbox>
        <mat-checkbox
          formControlName="updateDate"
          (change)="checkboxChanged($event)"
          matTooltip="isUpdated"
          matTooltipPosition="above"
        ></mat-checkbox>
        <mat-checkbox
          formControlName="filterable"
          (change)="checkboxChanged($event)"
          matTooltip="isFilterable"
          matTooltipPosition="above"
        ></mat-checkbox>
        <mat-checkbox
          formControlName="updatable"
          (change)="checkboxChanged($event)"
          matTooltip="isUpdated"
          matTooltipPosition="above"
        ></mat-checkbox>
        <mic-icon (click)="onDeleteColumn(i)" style="cursor: pointer" icon="delete"></mic-icon>
      </div>
    </div>
    }
  </div>
  <div class="icon-body">
    <div class="icon-container">
      <mic-icon (click)="onAddColumn()" style="cursor: pointer" icon="add"></mic-icon>
    </div>
  </div>
  <mat-form-field fxFill appearance="fill">
    <mat-label>Textarea</mat-label>
    <textarea formControlName="whereClose" matInput micScrollBar rows="3" placeholder="WHERE ..."></textarea>
  </mat-form-field>
  <mat-divider class="divider"></mat-divider>

  <div mat-dialog-actions class="btn-container">
    @if (tableVisualizationUpdated.tableVisualization) {
    <button type="submit" mat-raised-button color="warn">Update</button>
    } @else {
    <button type="submit" mat-raised-button color="primary" [disabled]="!tableVisualization.valid">Submit</button>
    }
  </div>
</form>
